module.exports = __webpack_public_path__ + "static/media/YM65_0.5411acaa.jpg";